module.exports = __webpack_public_path__ + "static/media/ntue.2876827d.pdf";